import React from 'react';

/**
 * Simple markdown text renderer that handles:
 * - Paragraphs (separated by blank lines)
 * - Bullet points (lines starting with - or *)
 * - Preserves line breaks
 */
const MarkdownText = ({ content, className = '' }) => {
  if (!content) return null;

  // Split by double newlines for paragraphs
  const paragraphs = content.split(/\n\n+/);

  return (
    <div className={className}>
      {paragraphs.map((paragraph, pIndex) => {
        // Check if this paragraph contains bullet points
        const lines = paragraph.split('\n');
        const hasBullets = lines.some(line => /^[\-\*]\s/.test(line.trim()));

        if (hasBullets) {
          // Render as a list
          const bulletItems = [];
          let currentText = [];

          lines.forEach((line, lIndex) => {
            const trimmed = line.trim();
            if (/^[\-\*]\s/.test(trimmed)) {
              // This is a bullet point
              if (currentText.length > 0) {
                bulletItems.push({ type: 'text', content: currentText.join('\n') });
                currentText = [];
              }
              bulletItems.push({ type: 'bullet', content: trimmed.replace(/^[\-\*]\s/, '') });
            } else if (trimmed) {
              currentText.push(trimmed);
            }
          });

          if (currentText.length > 0) {
            bulletItems.push({ type: 'text', content: currentText.join('\n') });
          }

          return (
            <div key={pIndex} className="mb-4">
              {bulletItems.map((item, iIndex) => {
                if (item.type === 'bullet') {
                  return (
                    <div key={iIndex} className="flex items-start gap-2 ml-2 mb-1">
                      <span className="text-primary mt-2 w-1.5 h-1.5 rounded-full bg-current shrink-0"></span>
                      <span>{item.content}</span>
                    </div>
                  );
                }
                return <p key={iIndex} className="mb-2">{item.content}</p>;
              })}
            </div>
          );
        }

        // Regular paragraph
        return (
          <p key={pIndex} className="mb-4 last:mb-0">
            {paragraph}
          </p>
        );
      })}
    </div>
  );
};

export default MarkdownText;
